$(document).ready(function() {

    var mqm = window.matchMedia('(min-width: 992px)');
    
    $(function() {
        if (mqm.matches) {
            if ($('.page-header.page-header-fixed').length) {
                $('.submenu').scrollToFixed({
                    marginTop: $('.page-top').outerHeight()
                });
                
                $('.menu').scrollToFixed({
                    marginTop: $('.page-top').outerHeight()
                });
                $('html:not(.ie9) .usr-view__img-container, html:not(.ie9) .usr-view__data-container').scrollToFixed({
                    marginTop: $('.page-top').outerHeight() + $('.navbar').outerHeight()
                });
            } else {
                if (($( window ).height() + $('.page-header').outerHeight(true) + $('.page-bar').outerHeight(true) + $('.menu').outerHeight(true)) < $( document ).height() ) {
                    $('.menu').scrollToFixed();
                }
            }
        }
    });
    
    if($('.infinite-paginator-button-wrapper').length) {
        $(document).on('click', '.infinite-paginator-button-wrapper a', function(e){
            
           
            $(this).closest('.infinite-paginator-button-wrapper').remove();

            var listURL = $(this).attr('href');
            $.ajax(
            {
                url : listURL,
                type: "GET",
                success:function(data, textStatus, jqXHR) 
                {
                    $('.infinite-paginator-content-wrapper').append(data);
                },
                error: function(jqXHR, textStatus, errorThrown) 
                {
                    
                }
            });
            e.preventDefault(); //STOP default action
        });
    }
    
    $(document).on('click', '.actionDelete', function(e){
       $("#deleteActionModal").find('a.actionDo').attr('href', $(this).attr('href'));
    });
    
    $(document).on('click', '#searchContainerTrigger', function(e){
        if ($(".search-form-container").hasClass('hidden')) {
            $(".search-form-container").removeClass('hidden');
        } else {
            $(".search-form-container").addClass('hidden');
        }
        e.preventDefault();
        return false;
     }); 
    
    

    $('.extended-list--tasks input[type="checkbox"]').on('click', function(){
        $(this).closest('form').submit(); 
    });

    // llistat 2 columnes
    $('.list-2cols, .duesCol').each(function(){
       $(this).find('li:even').addClass('even'); 
    });
    
    $('.textbox *:last-child').addClass('last');
    
    // --------
    // Megamenu (https://github.com/adobe-accessibility/Accessible-Mega-Menu/)
    // --------

    $("nav:first").accessibleMegaMenu({
        /* prefix for generated unique id attributes, which are required
           to indicate aria-owns, aria-controls and aria-labelledby */
        uuidPrefix: "accessible-megamenu",

        /* css class used to define the megamenu styling */
        menuClass: "nav-menu",

        /* css class for a top-level navigation item in the megamenu */
        topNavItemClass: "nav-item",

        /* css class for a megamenu panel */
        panelClass: "sub-nav",

        /* css class for a group of items within a megamenu panel */
        panelGroupClass: "sub-nav-group",

        /* css class for the hover state */
        hoverClass: "hover",

        /* css class for the focus state */
        focusClass: "focus",

        /* css class for the open state */
        openClass: "open"
    });

    (function() {

        var time = 600,
            timer;

        function handlerIn() {
            clearTimeout(timer);
            $('.sub-nav .intro').stop(true).css('opacity', 0).hide();
        }
        function handlerOut() {
            //if($('elemFoo').css('opacity') == 0) {
                timer = setTimeout(function() {
                    $('.sub-nav .intro').css('opacity', 1).fadeIn();
                }, time);

        }

        $(".sub-nav-group").hover(handlerIn, handlerOut);

    }());
    
    //prevenim click al menú principal amb submenús 
    // comentar aquesta funció si es decideix utilitzar menú amb hover!
    $( ".nav-item a[aria-haspopup]" ).on( "click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    });
    
    $( ".sub-nav .tancar" ).on( "click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        $('.nav-item a').removeClass('open focus').attr('aria-expanded', 'false');
        $('.sub-nav').removeClass('open').attr('aria-expanded', 'false');


    });

    // dropdown-list
    $(".dropdown-list ul").hide();
    $(".dropdown-list").on('click', 'a.has-dropdown',function(e){
        $(this).closest('li').find('ul').toggle();
        
        e.preventDefault();
        return false;
    });

    // calendari agenda portada
    if ($('#agendaCalendar').length) {
        $(document).on('click', '#agendaCalendar table.cal .cal__arrow a', function(e){
            
            var agendaURL = $(this).attr('href') + '/calendar';
            $('table.cal, table.cal .cal__arrow a').css('cursor', 'progress !important');
            $.ajax(
            {
                url : agendaURL,
                type: "GET",
                success:function(data, textStatus, jqXHR) 
                {
                    $('#agendaCalendar').html(data);
                    $('[data-toggle="popover"]').popover();
                    $('#agendaCalendar').fadeIn();
                },
                error: function(jqXHR, textStatus, errorThrown) 
                {
                    
                }
            });
            e.preventDefault(); //STOP default action
            
        });
    }    
    
    // alertes de portada
    $('.home .alertbox .alertbox__close').on('click', function(){
       if (Cookies) {
           var now = new Date();
           Cookies.set('alertbox_closed_on', now.getTime());
       }
    });
    
    if ($(".flashMessenger.alert").length > 0) {
        $(".flashMessenger.alert").alert(
            window.setTimeout(function() {
                $(".flashMessenger.alert").alert('close');
            }, 10000)
        );
    }
    
    $("#showAdvancedSearch").click(function(e){
    	e.preventDefault();
    	$(this.hash).fadeIn();
    	$(this).fadeOut();
    	return false;
    });
    
    // enquestes
    if ($('.pollcontainer').length) {
        
        var hashFingerPrint = '';
        new Fingerprint2().get(function(result, components){
            hashFingerPrint = result;
        });
        var userPrivateIp = ''; 
        getUserIP(function(ip){
                userPrivateIp = ip;
        });   
        
        setTimeout(initPolls, 1000);
        
        function initPolls() {
            
            $('.pollcontainer').each(function(){
                
                var enquestaId = $(this).attr('data-enquesta');
                var pollContainer = $(this);
                
                $.ajax(
                {
                    url : pollsURL + '/can-user-vote/' + enquestaId,
                    data: {fingerprint: hashFingerPrint, privateIp: userPrivateIp}, 
                    type: "POST",
                    success:function(data, textStatus, jqXHR) 
                    {
                        if (data == '1') {
                            pollContainer.find('.pollcontainer__form').fadeIn('fast');
                        } else {
                            pollContainer.find('.pollcontainer__results').fadeIn('fast');
                        }
                    },
                    error: function(jqXHR, textStatus, errorThrown) 
                    {
                        
                    }
                });
                
                $(this).find('input[type="submit"], button[type="submit"]').on('click', function(e){
                    e.preventDefault();
                    new Fingerprint2().get(function(result, components){
                        hashFingerPrint = result;
                        var form = pollContainer.find('form');
                        form.append('<input type="hidden" name="fingerprint" value="' + hashFingerPrint + '" />');
                        form.append('<input type="hidden" name="privateIp" value="' + userPrivateIp + '" />');
                        form.submit(); 
                    });
                })
            }); 
        }
    }

    /**
     * Get the user IP throught the webkitRTCPeerConnection
     * @param onNewIP {Function} listener function to expose the IP locally
     * @return undefined
     */
    function getUserIP(onNewIP) { //  onNewIp - your listener function for new IPs
        //compatibility for firefox and chrome
        var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
        
        if(typeof myPeerConnection == "undefined") {
	        	onNewIP = '';
	        	return;
        }
        
        var pc = new myPeerConnection({
            iceServers: []
        }),
        noop = function() {},
        localIPs = {},
        ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
        key;

        function iterateIP(ip) {
            if (!localIPs[ip]) onNewIP(ip);
            localIPs[ip] = true;
        }

         //create a bogus data channel
        pc.createDataChannel("");

        // create offer and set local description
        pc.createOffer().then(function(sdp) {
            sdp.sdp.split('\n').forEach(function(line) {
                if (line.indexOf('candidate') < 0) return;
                line.match(ipRegex).forEach(iterateIP);
            });

            pc.setLocalDescription(sdp, noop, noop);
        })
        ["catch"](function(reason) {
            // An error occurred, so handle the failure to connect
        });

        //listen for candidate events
        pc.onicecandidate = function(ice) {
            if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
            ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
        };
    }
});
